import { NewTag } from "@/design-system/Tags/NewTag/NewTag";
import { BREAKPOINTS } from "@/settings";
import { useTranslation } from "@repo/shared/i18n";
import { useMediaQuery } from "usehooks-ts";

export const SetHeaderTitle = ({
  title,
  isNew,
  hasRefreshed,
}: {
  title: string;
  isNew: boolean;
  hasRefreshed: boolean;
}) => {
  const { t } = useTranslation("common");
  const isTouchDevice = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);
  return (
    /* The set's name is the page's heading, so it is sized like one. It wraps
       where there is room for it and truncates on a phone, where a three-line
       name would push everything under it off the first screen. */
    <div className="flex min-w-0 flex-row items-center gap-x-3 pr-3 text-base font-bold leading-tight text-foreground desktop:text-2xl">
      <span className="max-desktop:truncate">{title}</span>
      {(isNew || hasRefreshed) && isTouchDevice && (
        <NewTag tag={isNew ? t("tags.new") : t("tags.refreshed")} />
      )}
    </div>
  );
};
